export default __webpack_public_path__ + "static/media/makanan.a988ac86.png";